import CheckCircleTwoToneIcon from '@mui/icons-material/CheckCircleTwoTone';
import { styled } from '@mui/material';
// ? Material Ui
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import Grid from '@mui/material/Grid';
import Paper from '@mui/material/Paper';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
// ? Next js
import Image from 'next/image';
import React from 'react';
import { API } from '_helpers';

const Item = styled(Paper)(({ theme }) => ({
  '&:hover': {
    boxShadow: '0 15px 25px 0 rgba(0,0,0,0.1)',
    background: 'rgba(255, 255, 255, 0.1)',
  },
  minHeight: 450,
}));

const ServiceIcon = styled(Stack)(({ theme }) => ({
  color: theme.palette.primary.main,
}));

const ServicesList: React.FC<IProps<IOurServices>> = ({ data }) => {
  return (
    <Box
      sx={{
        flexGrow: 1,
        py: { xs: 6, md: 12 },
      }}
    >
      <Container>
        <Stack spacing={2} sx={{ px: { xs: 0, md: 12, lg: 20 } }}>
          <Typography
            component="h2"
            color="text.primary"
            variant="h2"
            textAlign="center"
            gutterBottom
          >
            {data.title}
          </Typography>
          <Typography color="text.secondary" textAlign="center" gutterBottom>
            {data.description}
          </Typography>
        </Stack>

        <Grid container spacing={4} sx={{ py: 12 }}>
          {data.services.map((el, i) => (
            <Grid item xs={12} sm={6} md={4} key={i}>
              <Item variant="outlined" sx={{ p: 4 }}>
                <Stack
                  sx={{
                    width: 80,
                    height: 80,
                    bgcolor: 'primary.main',
                    borderRadius: 3,
                  }}
                  justifyContent="center"
                  alignItems="center"
                >
                  <Image
                    alt={el.media.alternativeText}
                    src={`${API}${el.media.url}`}
                    width={48}
                    height={48}
                  />
                </Stack>
                <Typography
                  component="h3"
                  variant="h3"
                  sx={{ my: 2 }}
                  fontWeight="bolder"
                >
                  {el.title}
                </Typography>
                <Typography color="text.secondary">{el.description}</Typography>
                <Typography
                  color="text.primary"
                  variant="h6"
                  fontWeight="bolder"
                  component="h3"
                  sx={{ my: 2 }}
                >
                  {el.label}
                </Typography>
                <Stack spacing={2}>
                  {el.items.map((_, i) => (
                    <Stack
                      direction="row"
                      alignItems="center"
                      spacing={2}
                      key={_._id}
                    >
                      <CheckCircleTwoToneIcon color="primary" />
                      <Typography color="text.secondary">{_.item}</Typography>
                    </Stack>
                  ))}
                </Stack>
              </Item>
            </Grid>
          ))}
        </Grid>
      </Container>
    </Box>
  );
};

export default ServicesList;
